import { Alert } from 'src/design/atoms/Alert';
import { Card } from 'src/design/atoms/Card';
import { Group } from 'src/design/atoms/Group';
import { Loader } from 'src/design/atoms/Loader';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { TextInput } from 'src/design/atoms/TextInput';
import React from 'react';
import { DailyQuestionDto } from 'src/api/FiretrolApiClient';
import { useQuestions } from 'src/api/queries/questions/useQuestions';
import {
  useCreateQuestion,
  useDeleteQuestion,
} from 'src/api/queries/questions/useQuestionMutations';
import { DeleteActionIcon } from 'src/design/molecules/DeleteActionIcon';
import { CreateButton } from 'src/design/atoms/CreateButton';
import { getErrorMessage } from 'src/utils';

interface IQuestionCardProps {
  jobId: number;
}

export const QuestionCard: React.FC<IQuestionCardProps> = ({ jobId }) => {
  const [value, setValue] = React.useState('');

  const { data, isLoading: loading, error } = useQuestions(jobId);
  const questions = data ?? [];
  const createQuestionMutation = useCreateQuestion(jobId);
  const deleteQuestionMutation = useDeleteQuestion(jobId);

  const createQuestion = () =>
    createQuestionMutation.mutate(value, { onSuccess: () => setValue('') });

  const removeQuestion = (q: DailyQuestionDto) =>
    deleteQuestionMutation.mutate(q.id);

  return (
    <Card>
      {error && (
        <Alert title="Error" color="red">
          {getErrorMessage(error)}
        </Alert>
      )}
      {loading ? (
        <Group justify="center" h={300}>
          <Loader />
        </Group>
      ) : (
        <Stack>
          {questions.length === 0 ? (
            <Text>No questions to display</Text>
          ) : (
            questions.map((q) => (
              <Paper key={q.id} p="xs">
                <Group justify="space-between">
                  <Text c="black">{q.question}</Text>
                  <DeleteActionIcon
                    requiredConfirmation={true}
                    confirmationTitle="Remove Question"
                    confirmationText="Are you sure you want to remove this question?"
                    onDelete={() => removeQuestion(q)}
                  />
                </Group>
              </Paper>
            ))
          )}
          <Group>
            <TextInput
              placeholder="Enter question..."
              value={value}
              onChange={(e) => setValue(e.target.value)}
              style={{ flex: 1 }}
            />
            <CreateButton
              onClick={createQuestion}
              disabled={value.length === 0}
              loading={createQuestionMutation.isPending}
            >
              Add
            </CreateButton>
          </Group>
        </Stack>
      )}
    </Card>
  );
};
